<template>
    <div class="mt-4 mb-8 flex flex-wrap items-center justify-between gap-2">
        <task-group-badge v-if="group" :bg-color="getTaskGroupColor(group)" :group="group" />
        <div v-if="code" class="">{{ code }}</div>
    </div>
</template>
<script setup>
import TaskGroupBadge from './TaskGroupBadge.vue';
import { getTaskGroupColor } from '@/Pages/TaskList/utils';

defineProps(['code', 'group']);
</script>
